import { UPFLOWY_DOM_ID, WATCHER_MODE } from '../settings';
import { Detection } from '../types';
import Session from './sessions/Session';

class DetectionTimeline {
  detections: Detection[] = [];

  addDetection(
    target: Element,
    event: Event,
    session: Session,
    startTime: number,
    duration: number | null = null,
    properties: Record<string, unknown> = {},
  ) {
    const data = {
      createdAt: Date.now(),
      uwid: target.getAttribute(UPFLOWY_DOM_ID),
      sessionId: session.id,
      eventType: event.type,
      startTime,
      duration,
      properties,
    };
    const detection: Detection = {
      ...data,
      element: target,
    };
    if (WATCHER_MODE !== 'lean') {
      this.detections.push(detection);
    }
    return detection;
  }

  getDetections(minDuration: number) {
    return this.detections.filter((detection) => {
      if (detection.duration && detection.duration < minDuration) {
        return false;
      }
      return true;
    });
  }

  static serializeDetection(detection: Detection) {
    const serializedDetection: Record<string, unknown> = { ...detection };
    delete serializedDetection.element;
    return serializedDetection;
  }
}

export default DetectionTimeline;
